export const EXCMDAILYPLANITEM_DELETE_RESET = 'EXCMDAILYPLANITEM_DELETE_RESET'
export const EXCMDAILYPLANITEM_DELETE_SET_ERROR = 'EXCMDAILYPLANITEM_DELETE_SET_ERROR'
export const EXCMDAILYPLANITEM_DELETE_SET_DELETED = 'EXCMDAILYPLANITEM_DELETE_SET_DELETED'
export const EXCMDAILYPLANITEM_DELETE_TOGGLE_LOADING = 'EXCMDAILYPLANITEM_DELETE_TOGGLE_LOADING'
